import { useEffect, useState } from 'react'
import { useReadMonitorRunResultGroupedByMonitorIdQuery } from 'services/monitorRunResult'
import { RecommendationListTable } from '../../presentationals/RecommendationListTable'

interface RecommendationListContainerProps {
    marketSpyId?: number,
    marketSpyRunResult?: any,
    onSelectedMonitorLaunchTaskChange?: (event: any) => void
}

export const RecommendationListContainer = (props: RecommendationListContainerProps): JSX.Element => {
    const {
        marketSpyId,
        marketSpyRunResult,
        onSelectedMonitorLaunchTaskChange,
    } = props

    const [recommendationList, setRecommendationList] = useState<any | undefined>()
    const [useReadMonitorRunResultGroupedByMonitorIdQueryParams, setUseReadMonitorRunResultGroupedByMonitorIdQueryParams] = useState<any>({
        monitorId: marketSpyId
    })

    const [useReadMonitorRunResultGroupedByMonitorIdQueryOptions, setUseReadMonitorRunResultGroupedByMonitorIdQueryOptions] = useState<any>({
            skip: marketSpyId === undefined,
            refetchOnMountOrArgChange: true,
            pollingInterval: 5000,
    })

    const {
        data: readMonitorRunResultGroupedByMonitorIdData,
        isLoading: readMonitorRunResultGroupedByMonitorIdIsLoading,
        isFetching: readMonitorRunResultGroupedByMonitorIdIsFetching,
    } = useReadMonitorRunResultGroupedByMonitorIdQuery(
        useReadMonitorRunResultGroupedByMonitorIdQueryParams,
        useReadMonitorRunResultGroupedByMonitorIdQueryOptions
    )

    useEffect(() => {
        setUseReadMonitorRunResultGroupedByMonitorIdQueryParams((prev: any) => {
            return {
                monitorId: marketSpyId
            }
        })

        setUseReadMonitorRunResultGroupedByMonitorIdQueryOptions((prev: any) => {
            return {
                ...prev,
                skip: marketSpyId === undefined
            }
        })
        }, [
            marketSpyId
       ])

    useEffect(() => {
        if (readMonitorRunResultGroupedByMonitorIdData === undefined) {
            setRecommendationList(undefined);

            return;
        }

        const recomendations = readMonitorRunResultGroupedByMonitorIdData.list
            .map((item: any) => {
                const recDirectionToHigh = Math.round(item.recValue) >= item.medianPrice;

                let textRecommendation = `Do nothing`;

                if (item.recDir === 1) {
                    textRecommendation = `Set total price to ${recDirectionToHigh ? '≥' : '≤'} $${Math.round(item.recValue)}`;
                }


                if (item.recDir === -1) {
                    textRecommendation = `Set total price to ${recDirectionToHigh ? '≥' : '≤'} $${Math.round(item.recValue)}`;
                }

                return {
                    id: item.id,
                    monitorLaunchTask: item,
                    recommendation: {
                        text: textRecommendation,
                        status: item.isRecOn,
                        priceDirection: item.recDir
                    },
                    date: item.checkinUtc
                };
            })
            .reverse()

        setRecommendationList(recomendations);
    },
        [
            readMonitorRunResultGroupedByMonitorIdData
        ]
    )

    const handleItemClick = (event: any) => {
        onSelectedMonitorLaunchTaskChange?.({
            monitorLaunchTask: event.monitorLaunchTask
        })
    }

    return (
        <>
            <RecommendationListTable
                recomendations={recommendationList}
                onItemClick={handleItemClick}
                selectedRowId={marketSpyRunResult?.id}
            />
        </>
    )
}